export const moduleName = 'firebase'

export type SignInPayload = {
  email: string
  password: string
}
